<script setup>
import { computed } from 'vue'

import ModalDrawer from './components/ModalDrawer.vue'
import { getStrings } from './lib/i18n'

const props = defineProps({
  lang: {
    type: String,
    default: 'en',
  },
  market: {
    type: String,
    default: '',
  },
})

const strings = computed(() => getStrings(props.lang))
const getMarketFromUrl = () => {
  if (typeof window === 'undefined') return ''
  const params = new URLSearchParams(window.location.search)
  return params.get('market') || ''
}
const resolvedMarket = computed(() => props.market || getMarketFromUrl() || 'UKMyson')
</script>

<template>
  <div class="room-calculator app-root">
    <ModalDrawer
      :model-value="true"
      :inline="true"
      :show-close="false"
      :close-on-use="false"
      :strings="strings"
      :market="resolvedMarket"
    />
  </div>
</template>

<style src="./styles/base.css"></style>

<style scoped>
.room-calculator {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
}
</style>
